import {error} from 'console'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../parts/crud/Charts'
import {DataRangeFilter} from '../../parts/filters/DataRangeFilter'
import {EventCategoryFilter} from '../../parts/filters/EventCategoryFilter'
import {ServerFilter} from '../../parts/filters/ServerFilter'
import {useState} from 'react'
import {useIntl} from 'react-intl'
import moment from 'moment'
import {getBaseBarChartOptions} from '../../parts/crud/Types'

export const EventsDuration = () => {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(6, 'days'),
    end: moment(),
  })
  const [server, setServer] = useState('all')
  const [groupSelected, setGroupSelected] = useState<any>(null)
  const [serversSelected, setServersSelected] = useState([])
  const [error, setError] = useState('')
  const [eventCategory, setEventCategory] = useState(null)
  const [categorySelected, setCategorySelected] = useState<any>(null)
  const [error_category, setErrorCategory] = useState('')

  let params: any = {
    title: intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_DURATION.TITLE'}),
    yAxisTitle: intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_DURATION.YAXISTITLE'}),

    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.0f} </b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true,
  }
  let baseChartOptions: any = {...getBaseBarChartOptions(params)}
  baseChartOptions.legend = {
    layout: 'vertical',
    align: 'left',
    verticalAlign: 'top',
    x: 150,
    y: 100,
    title: {
        text: intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_DURATION.LEGEND_TITLE'})
    },
    floating: true,
    draggable: true,
    borderWidth: 1,
    backgroundColor:  '#FFFFFF'
};

  const submitData = async () => {
    let has_error = false
    setError('')
    if (  server === 'oneormore' && (serversSelected === null || (Array.isArray(serversSelected) && serversSelected.length === 0))) {
      setError(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_SERVER'}))
      has_error = true
    }
    setErrorCategory('')
    if (eventCategory === '0' && (categorySelected === null || (Array.isArray(categorySelected) && categorySelected.length === 0))) {
      setErrorCategory(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_CATEGORY'}))
      has_error = true
    }
    if (has_error) {
      return
    }
    setErrorCategory('')
    let data: any = {
      date_range: {
        start: dateRange.start.format('YYYY-MM-DD') + ' 00:00:00',
        end: dateRange.end.format('YYYY-MM-DD') + ' 23:59:59',
      },
      server: server,
      group_list: groupSelected ? groupSelected.value : null,
      selected_server: server === 'oneormore' && serversSelected ? serversSelected.map((srv: any) => srv.value) : [],
      tz: new Date().getTimezoneOffset(),
      event_category: eventCategory,
      category_selected: categorySelected && eventCategory === '0' ? categorySelected.map((cat: any) => cat.value) : [],
    }
    setFilterData(data)
  }

  return (
    <>
      <CrudProvider api='diagnostic/events-duration'>
        <ChartsComponent
          setLoading={(loading) => {
            setLoading(loading)
          }}
          filterData={filterData}
          baseChartOptions={baseChartOptions}
        >
          <p>{intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_DURATION.TEXT'})}</p>
          <DataRangeFilter
            onChangedDataRange={(start, end) => {
              setDateRange({
                start: start,
                end: end,
              })
            }}
          />
          <ServerFilter
            onChangedServer={(server) => {
              setServer(server)
            }}
            onChangedServersSelected={(servers) => {
              setServersSelected(servers)
            }}
            onGroupSelected={(group) => {
              setGroupSelected(group)
            }}
          />
          {error && <div className='alert alert-danger'>{error}</div>}
          <EventCategoryFilter
            onChangedEventCategory={(eventCategory: any) => {
              setEventCategory(eventCategory)
            }}
            onChangedCategorySelected={(categorySelected: any) => {
              setCategorySelected(categorySelected)
            }}
          />
          {error_category && <div className='alert alert-danger'>{error_category}</div>}
          <input
            type='button'
            disabled={loading}
            className='btn btn-primary'
            onClick={submitData}
            value={intl.formatMessage({id: 'GENERIC.SUBMIT'})}
            style={{float: 'left'}}
          />{' '}
          {loading && (
            <div
              className='spinner-border text-primary'
              role='status'
              style={{marginTop: '7px', float: 'left', marginLeft: '10px'}}
            >
              <span className='visually-hidden'>Loading...</span>
            </div>
          )}
        </ChartsComponent>
      </CrudProvider>
    </>
  )
}
